import { makeStyles } from '@material-ui/core/styles'

export const useTitleStyles = makeStyles(() => ({
	subtitle: {
		fontWeight: 600,
	},
}))
